<template>
  <section-container>
    <div class="w-full flex justify-center items-center flex-wrap p-2">
      <div class="w-full lg:w-1/3 flex flex-wrap flex-col">
        <h2 class="text-4xl font-bold mb-2">Produtos no catálogo</h2>
        <h4 class="text-xl mb-5">Gerencie os produtos da loja</h4>
        <div class="my-5">
          <button-icon
            @click.native="createProduct"
            icon="plus"
            text="Adicionar novo produto"
            class="bg-indigo-600"
          />
        </div>
      </div>
      <div
        class="w-full lg:w-2/3 justify-center items-center px-4 my-4 hidden md:flex"
      >
        <img
          src="@/assets/img/stock.png"
          alt=""
          width="650px"
          class="h-auto overflow-hidden"
        />
      </div>
    </div>
    <ui-confirm
      ref="scaleDownConfirm"
      title="Você gostaria de remover?"
      transition="scale-down"
      confirmButtonText="Deletar"
      type="danger"
      confirmButtonIcon="delete"
      @confirm="onConfirm"
      @deny="onDeny"
      >Você gostaria de remover?</ui-confirm
    >
    <content-e v-if="Object.keys(products).length > 0">
      <div class="w-full p-2" v-if="products.data.length <= 0">
        <alert-empty></alert-empty>
      </div>
      <div
        class="w-full md:w-1/2 p-2"
        v-for="product in products.data"
        :key="product.id"
      >
        <div class="" v-if="product">
          <product-card
            :product_name="product.name"
            :price="parseFloat(product.price)"
            :stock="parseInt(product.stock)"
            :store_id="storeId"
            :product_id="product.id"
            :image="product.thumb"
            v-on:product_deleted="doDeleteProduct"
          />
        </div>
      </div>
      <div class="w-full" v-if="products.last_page > 1">
        <pagination
          :pagination="products"
          @paginate="doMyProductsByStore()"
          :offset="3"
        ></pagination>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import Pagination from '@/components/Pagination'
import AlertEmpty from '@/components/Alert/AlertEmpty'
import ProductCard from '@/components/Store/Product/ProductCard'
export default {
  components: {
    ProductCard,
    AlertEmpty,
    Pagination
  },
  computed: {
    storeId() {
      return this.$store.state.store.id
    }
  },
  data() {
    return {
      products: {},
      product_deleted: null
    }
  },

  methods: {
    showConfirm(ref, token) {
      this.product_deleted = token
      this.$refs[ref].open()
    },
    hideConfirm(ref) {
      this.$refs[ref].close()
    },
    async doMyProductsByStore() {
      const data = {
        page: this.products.current_page,
        store_id: this.storeId
      }
      const products = await this.$store.dispatch(
        'store/MY_PRODUCT_BY_STORE',
        data
      )
      this.products = products.data.data
    },
    doDeleteProduct(e) {
      this.showConfirm('scaleDownConfirm', e)
    },
    onConfirm() {
      const data = {
        store_id: this.storeId,
        product_id: this.product_deleted
      }
      this.$store
        .dispatch('store/DELETE_PRODUCT_BY_STORE', data)
        .then(response => {
          this.$toasted.success(response.data.message, {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.doMyProductsByStore()
        })
    },
    onDeny() {
      this.confirmResult = 'You denied the request.'
    },
    async createProduct() {
      const product = await this.$store.dispatch('store/CREATE_PRODUCT_STORE', {
        name: null
      })
      this.$router.push({
        name: 'store.product.show',
        params: { product: product.data.id }
      })
      console.log(product)
    }
  },
  async created() {
    await this.doMyProductsByStore()
  }
}
</script>
